import React from 'react'

export const ConfigJsonToggle = ({ jsonMode, onToggle, hasVisualEditor, parseError }) => {
  return (
    <div style={{ marginBottom: '1rem' }}>
      <label style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', fontWeight: 'normal' }}>
        <input
          type="checkbox"
          checked={jsonMode}
          onChange={(e) => onToggle(e.target.checked)}
          style={{ marginRight: '6px' }}
        />
        JSON Mode
      </label>
      {!hasVisualEditor && !jsonMode && (
        <span style={{ marginLeft: '12px', color: '#856404', fontSize: '13px' }}>
          No visual editor available for this plugin. Use JSON Mode to edit configuration.
        </span>
      )}
      {parseError && (
        <div style={{ marginTop: '6px', color: '#dc3545', fontSize: '13px' }}>
          {parseError}
        </div>
      )}
    </div>
  )
}
